module.exports = __webpack_public_path__ + "static/media/game-end.459cd02c.svg";